import React, { useContext } from "react";
import UICarousel from "ui/UICarousel";
import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";

import { useLivePersonas } from "hooks/dbHooks";

const UIPersonaManager = (props) => {
  const { globalState, globalDispatch } = useContext(GlobalContext);
  const { databaseState } = useContext(DatabaseContext);
  const livePersonas = useLivePersonas(
    databaseState.dbMaster,
    globalState.muid
  );
  let itemList = livePersonas
    ? livePersonas.map((persona) => ({
        id: persona.persona,
        onClick: () => {
          globalDispatch({
            type: "SET_PERSONA",
            values: { persona: persona },
          });
        },
      }))
    : [];

  let items = itemList.map((item) => (
    <div key={item.id} id={item.id} onClick={item.onClick} className="item">
      {item.id}
    </div>
  ));
  let content = (
    <div className="UI-persona-frame">
      <UICarousel items={items} />
    </div>
  );
  return content;
};

export default React.memo(UIPersonaManager, (prevProps, nextProps) => {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});
